// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_core_feature_login_login_module_ts":"e3bd3e106ae7f56e74cc","default-node_modules_primeng_fesm2015_primeng-table_js":"2b22f3d3e0bd77f290b8","src_app_core_feature_admin_admin_module_ts":"ffe371a578146243bb90","src_app_core_feature_dashboard_dashboard_module_ts":"e7b06ec76c0f9f96f1a5"}[chunkId] + ".js";
};